var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "button-preview",
      class: { "stan-device preview-type-store new": _vm.showDevice }
    },
    [
      _c("div", { staticClass: "site-preview-section" }, [
        _c(
          "div",
          {
            staticClass:
              "store-theme mx-auto site__prev__masking place-content-center",
            class: _vm.storeTheme,
            staticStyle: { "max-width": "405px" }
          },
          [
            _c(
              "div",
              { staticClass: "store-content" },
              [
                _vm.type == "lead-magnet"
                  ? [
                      _c("LeadMagnetButton", {
                        ref: "form",
                        attrs: {
                          user: _vm.user,
                          title: _vm.product.title,
                          button_text:
                            _vm.config.button_text || _vm.config.title,
                          heading: _vm.config.heading,
                          image: _vm.config.image,
                          tagline: _vm.config.tagline,
                          questions: _vm.config.questions,
                          disabled: true
                        }
                      })
                    ]
                  : _vm.config.layout.toLowerCase() === "preview"
                  ? [
                      _c("SitePreviewButton", {
                        ref: "form",
                        attrs: {
                          user: _vm.user,
                          title: _vm.product.title,
                          button_text: _vm.config.button_text,
                          heading: _vm.config.heading,
                          image: _vm.config.image,
                          tagline: _vm.config.tagline,
                          price: _vm.product.price,
                          product: _vm.product,
                          currency: _vm.user.data.currency,
                          reviews: _vm.product.reviews,
                          productType: _vm.product.type,
                          quantity: _vm.productQuantity(_vm.product),
                          editable: _vm.editable,
                          animate: _vm.animate
                        },
                        on: {
                          imageEdit: _vm.handleImageEdit,
                          taglineUpdate: _vm.handleTaglineUpdated,
                          buttonUpdate: _vm.handleButtonUpdated,
                          titleUpdate: _vm.handleTitleUpdated,
                          editorOpened: _vm.handleEditorOpened
                        }
                      })
                    ]
                  : _vm.config.layout.toLowerCase() === "callout"
                  ? [
                      _c("SiteCalloutButton", {
                        ref: "form",
                        attrs: {
                          user: _vm.user,
                          title: _vm.product.title,
                          button_text: _vm.config.button_text,
                          heading: _vm.config.heading,
                          image: _vm.config.image,
                          tagline: _vm.config.tagline,
                          price: _vm.product.price,
                          reviews: _vm.product.reviews,
                          productType: _vm.product.type,
                          currency: _vm.user.data.currency,
                          quantity: _vm.productQuantity(_vm.product),
                          editable: _vm.editable,
                          animate: _vm.animate
                        },
                        on: {
                          imageEdit: _vm.handleImageEdit,
                          taglineUpdate: _vm.handleTaglineUpdated,
                          buttonUpdate: _vm.handleButtonUpdated,
                          titleUpdate: _vm.handleTitleUpdated,
                          editorOpened: _vm.handleEditorOpened
                        }
                      })
                    ]
                  : _vm.config.layout.toLowerCase() === "button"
                  ? [
                      _c("SiteButton", {
                        ref: "form",
                        attrs: {
                          user: _vm.user,
                          title: _vm.product.title,
                          image: _vm.config.image,
                          price: _vm.product.price,
                          reviews: _vm.product.reviews,
                          productType: _vm.product.type,
                          currency: _vm.user.data.currency,
                          quantity: _vm.productQuantity(_vm.product),
                          editable: _vm.editable,
                          animate: _vm.animate
                        },
                        on: {
                          imageEdit: _vm.handleImageEdit,
                          titleUpdate: _vm.handleTitleUpdated,
                          editorOpened: _vm.handleEditorOpened
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }